import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import parse from 'html-react-parser';
import { format } from 'date-fns';

import { dateTimeFormat } from 'constants/formats';

import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';
import { getRecipientMails } from '../utils/getRecipientMails';
import RecipientsTable from './RecipientsTable';

const CertificationViewBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useCommunicationDetailsPage();

  const { communication } = data;

  const parsedDocument = communication?.body ? parse(communication.body) : '';
  const recipientMails = getRecipientMails(communication?.recipients || []);

  return (
    <div className="nk-block m-0">
      <div className="invoice">
        <div className="invoice-action">
          <span className="fs-20px">
            <em className="icon ni ni-shield-check-fill" />
          </span>
        </div>
        <div className="invoice-wrap" style={{ overflow: 'hidden' }}>
          <div className="invoice-head">
            <div className="invoice-contact">
              <span className="overline-title">{t('Email')}</span>
              <div className="invoice-contact-info">
                <h4 className="title">{communication?.subject}</h4>
                <ul className="list-plain">
                  <li>
                    <em className="icon ni ni-user-alt" />
                    <span>
                      {t('Sender')}:
                      <br /> {communication?.sender?.email}
                    </span>
                  </li>

                  <li>
                    <em className="icon ni ni-calendar" />
                    <span>
                      {t('SentDate')}:
                      <br />
                      {communication?.date
                        ? format(new Date(communication?.date), dateTimeFormat)
                        : ''}
                    </span>
                  </li>

                  <li>
                    <em className="icon ni ni-user-alt" />
                    <span>{t('Recipient(s)')}:</span>
                    <br />
                    <div className="ml-4">
                      <span className="text-soft">{recipientMails}</span>
                    </div>
                  </li>

                  <li>
                    <em className="icon ni ni-mail" />
                    <span>
                      {t('Subject')}:
                      <br /> {communication?.subject}
                    </span>
                  </li>

                  <li>
                    <em className="icon ni ni-file" />
                    <span>
                      {t('AttachedFiles')}:
                      <br />
                      {data?.attachedDocuments &&
                      data?.attachedDocuments.length > 0
                        ? data.attachedDocuments?.map((attachment) => (
                            // eslint-disable-next-line react/jsx-indent
                            <span className="d-block" key={attachment?._id}>
                              {attachment?.name}
                            </span>
                          ))
                        : t('NoAttachments')}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="invoice-body">
            <span className="overline-title">{t('Textual')}</span>
            <br />
            <div className="nk-ibx-context">
              <span className="nk-ibx-context-text">
                <br />
                <div className="nk-reply-entry entry">
                  <div
                    style={{
                      whiteSpace:
                        typeof parsedDocument === 'string'
                          ? 'pre-line'
                          : 'normal',
                    }}
                  >
                    {parsedDocument || ''}
                  </div>
                </div>
              </span>
            </div>
            <br />
          </div>

          <div
            className="invoice-bills"
            style={{ overflowX: 'auto', maxWidth: '100%' }}
          >
            <RecipientsTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificationViewBody;
